import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import './app.scss';
import { Provider } from 'react-redux';
import { SnackbarOrigin, SnackbarProvider } from 'notistack';
import store, { history } from './store/Index';
import App from './App';
import red from '@mui/material/colors/red';
import orange from '@mui/material/colors/orange';
import blue from '@mui/material/colors/blue';
import { ClearCacheProvider } from '@zz2/zz2-ts-utilities';
import { Router } from 'react-router-dom';
import materialTheme from './styles/materialTheme';
import EnvHelper from './services/helper/envHelper';
import makeStyles from '@mui/styles/makeStyles';
import { SNACKBAR_WIDTH } from './appConstants';

if (process.env.NODE_ENV === 'production') {
    // eslint-disable-next-line no-console
    console.log('Production?', process.env.NODE_ENV);
}

const snackBarProviderAnchor : SnackbarOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
};

const AppRoot = () => {
    document.title = EnvHelper.getEnvName();

    const useStyles = makeStyles(() => ({
        success: { backgroundColor: materialTheme.palette.primary.main, width: SNACKBAR_WIDTH },
        error: { backgroundColor: red[600], width: SNACKBAR_WIDTH },
        warning: { backgroundColor: orange[600], width: SNACKBAR_WIDTH },
        info: { backgroundColor: blue[600], width: SNACKBAR_WIDTH },
    }));

    const classes = useStyles();

    const snackBarProviderClasses = {
        variantSuccess: classes.success,
        variantError: classes.error,
        variantWarning: classes.warning,
        variantInfo: classes.info,
    };

    return (
        <Provider store={store}>
            <Router history={history}>
                <SnackbarProvider 
                    maxSnack={4}
                    anchorOrigin={snackBarProviderAnchor}
                    classes={snackBarProviderClasses}
                >
                    <StrictMode>
                        <App/>
                    </StrictMode>
                </SnackbarProvider>
            </Router>
        </Provider>
    );
};

const rootDomElement = document.getElementById('root');

if (rootDomElement) {
    ReactDOM.render(<ClearCacheProvider><AppRoot /></ClearCacheProvider>, rootDomElement);
}
